import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen h-full w-full bg-gradient-to-br from-neutral-950 via-neutral-800 to-neutral-700" }
const _hoisted_2 = { class: "flex flex-col md:flex-row justify-center items-center" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "text-4xl prose text-white py-4 font-semibold" }, "WindyOTP", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl prose text-neutral-300" }, "Your personal otp experience", -1)
const _hoisted_6 = { class: "block md:hidden w-4/5 mx-auto" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row pt-8 justify-evenly" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "border-b-2 border-spacing-2 border-lime-400 text-white",
    href: "https://github.com/robbryandev/WindyOTP/releases"
  }, "Download"),
  /*#__PURE__*/_createElementVNode("a", {
    class: "border-b-2 border-spacing-2 border-lime-400 text-white",
    href: "https://github.com/robbryandev/WindyOTP"
  }, "Github")
], -1)
const _hoisted_8 = { class: "relative top-20 left-20 md:block hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PhoneDisplay = _resolveComponent("PhoneDisplay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_PhoneDisplay)
        ]),
        _hoisted_7
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_PhoneDisplay)
      ])
    ])
  ]))
}